import { useEffect, useState } from "react";
import { usePeriodoInventario } from "../../../../contexto/provider/InventarioPeriodosContext.js";
import "../../../../componentsUI/tablas/tablaGenerica.css";

import VentanaPeriodo from "../inventarios/ventanaEmergente.js";

export default function ControlPeriodoInventario() {
  const { periodos, loading, listarPeriodos } = usePeriodoInventario();
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);

  useEffect(() => {
    listarPeriodos();
  }, [listarPeriodos]);

  return (
    <div>
      <div className="tabla-container">
        <span>Abrir o cerrar periodos de inventario</span>

        {loading ? (
          <p>Cargando periodos...</p>
        ) : (
          <div className="tabla-scroll">
            <table className="tabla-reporte">
              <colgroup>
                <col className="col-1" />
                <col className="col-2" />
                <col className="col-3" />
              </colgroup>

              <thead>
                <tr>
                  <th>Mes</th>
                  <th>Fecha Inicio</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {periodos.map((p) => (
                  <tr key={p.id}>
                    <td>{p.mes}</td>
                    <td>{p.fecha_fin}</td>

                    <td>
                      <button
                        className={`btn-estado ${p.estado}`}
                        onClick={() => setPeriodoSeleccionado(p)}
                      >
                        {p.estado === "abierto" ? "Abierto" : "Cerrado"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {periodoSeleccionado && (
        <VentanaPeriodo
          periodo={periodoSeleccionado}
          onClose={() => setPeriodoSeleccionado(null)}
        />
      )}
    </div>
  );
}
